module.exports = __webpack_public_path__ + "static/media/validacao_email_white.27a0ee67.svg";